export default function PrivacyPolicyPage () {
    return(
        <section className="p-8 mt-10">
        <h1 className="text-[32px] mb-1 font-semibold">Privacy Policy for AdMentorAI</h1>
        <p><strong>Last updated:</strong> May 16, 2025</p>
        
        <p className="mt-3">This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
        
        <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>

        <h2 className="font-semibold underline my-3">Interpretation and Definitions</h2>
        <h3 className="font-semibold">Interpretation  :</h3>
        <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

        <h3 className="font-semibold">Definitions</h3>
        <p>For the purposes of this Privacy Policy:</p>
        <ul className="list-inside px-4 py-2">
            <li><strong>• Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
            <li><strong>• Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party.</li>
            <li><strong>• Company</strong> (referred to as either "the Company", "We", "Us" or "Our") refers to AdMentorAI.</li>
            <li><strong>• Cookies</strong> are small files placed on Your device by a website.</li>
            <li><strong>• Country</strong> refers to Maharashtra, India.</li>
            <li><strong>• Device</strong> means any device that can access the Service such as a computer or a mobile phone.</li>
            <li><strong>• Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
            <li><strong>• Service</strong> refers to the Website.</li>
            <li><strong>• Service Provider</strong> means any natural or legal person who processes data on behalf of the Company.</li>
            <li><strong>• Third-party Social Media Service</strong> refers to any social network through which a User can log in.</li>
            <li><strong>• Usage Data</strong> refers to data collected automatically from use of the Service.</li>
            <li><strong>• Website</strong> refers to AdMentorAI, accessible at <a target="_blank" rel="noreferrer" href="https://admentorai.com">https://admentorai.com</a>.</li>
            <li><strong>• You</strong> means the individual accessing the Service, or the company/entity they represent.</li>
        </ul>

        <h2 className="font-semibold my-2">Collecting and Using Your Personal Data</h2>
        <h3 className="font-semibold underline mb-4">Types of Data Collected</h3>
        <h4 className="font-semibold">Personal Data</h4>
        <p>We may ask You to provide Us with certain personally identifiable information, including:</p>
        <ul className="px-4">
            <li>• Email address</li>
            <li>• First and last name</li>
            <li>• Phone number</li>
            <li>• Usage Data</li>
        </ul>

        <h4 className="font-semibold">Usage Data</h4>
        <p>Collected automatically and may include information like:</p>
        <ul className="px-4">
            <li>• IP address</li>
            <li>• Browser type and version</li>
            <li>• Pages visited</li>
            <li>• Time/date of visit</li>
            <li>• Time spent on pages</li>
            <li>• Device info</li>
        </ul>

        <h4 className="font-semibold">From Third-Party Social Media Services</h4>
        <p>We may collect info via:</p>
        <ul className="px-4">
            <li>• Google</li>
            <li>• Facebook</li>
            <li>• Instagram</li>
            <li>• Twitter</li>
            <li>• LinkedIn</li>
            <li>• Tiktok</li>
        </ul>

        <h3 className="font-semibold">Tracking Technologies and Cookies</h3>
        <p>We use Cookies and similar tracking technologies:</p>
        <ul className="px-4">
            <li><strong>• Session Cookies</strong>: necessary for services.</li>
            <li><strong>• Persistent Cookies</strong>: save preferences and consent.</li>
            <li><strong>• Web Beacons</strong>: count page views or email opens.</li>
        </ul>
        <p className="my-2">For details, visit our Cookie Policy.</p>

        <h2 className="font-semibold my-2">Use of Your Personal Data</h2>
        <p>We may use data to:</p>
        <ul className="px-4">
            <li>• Provide and maintain our Service</li>
            <li>• Manage Your Account</li>
            <li>• Perform contract obligations</li>
            <li>• Contact You via email/SMS/push</li>
            <li>• Send promotional offers</li>
            <li>• Analyze and improve our Service</li>
            <li>• Business transfers</li>
            <li>• With Your consent</li>
        </ul>

        <h2 className="font-semibold my-2">Retention of Your Personal Data</h2>
        <p>We retain Personal Data only as long as necessary and in compliance with legal obligations.</p>

        <h2 className="font-semibold my-2">Transfer of Your Personal Data</h2>
        <p>Your data may be processed outside Your jurisdiction. We ensure adequate protection measures.</p>

        <h2 className="font-semibold my-2">Delete Your Personal Data</h2>
        <p>You may delete or request deletion of Your data via account settings or by contacting us.</p>

        <h2 className="font-semibold my-2">Disclosure of Your Personal Data</h2>
        <ul className="px-4">
            <li>• Business Transactions</li>
            <li>• Law Enforcement Requests</li>
            <li>• Legal Requirements</li>
        </ul>

        <h2 className="font-semibold my-2">Security of Your Personal Data</h2>
        <p>We strive to protect Your data but cannot guarantee absolute security.</p>

        <h2 className="font-semibold my-2">Children’s Privacy</h2>
        <p>We do not knowingly collect data from users under 13. If we do, we delete it.</p>

        <h2 className="font-semibold my-2">Links to Other Websites</h2>
        <p>We are not responsible for external websites linked within our Service.</p>

        <h2 className="font-semibold my-2">Changes to this Privacy Policy</h2>
        <p>We may update this policy. Check periodically. We notify via email or notice on Service.</p>

        <h2 className="font-semibold my-2">Contact Us</h2>
        <p>If you have any questions, contact us at: <a target="_blank" rel="noreferrer" className="text-blue-700" href="mailto:support@admentorai.com">support@admentorai.com</a></p>
        </section>
    )
}
